import $ from 'jquery'

export default () => {
  $(() => {
    if (! $('body').hasClass('page-template-contact')) return

    $('form#contact').submit(e => {
      e.preventDefault()
      let $form = $(e.target)
      $form.find('.invalid').removeClass('invalid')

      let data = {
        'name': $form.find('input[name="name"]').val(),
        'company': $form.find('input[name="company"]').val(),
        'phone': $form.find('input[name="phone"]').val(),
        'email': $form.find('input[name="email"]').val(),
        'address': $form.find('input[name="address"]').val(),
        'subject': $form.find('input[name="subject"]').val(),
        'body': $form.find('textarea[name="body"]').val()
      }

      if (!validation($form, data)) return

      $.post(window.endpoint + '/contact', {
        name: data.name,
        company: data.company,
        phone: data.phone,
        email: data.email,
        address: data.address,
        subject: data.subject,
        body: data.body
      })
        .done(() => {
          $form.children().hide()
          $form.prepend('<div class="tq-msg mt-20"><p>Cảm ơn quý khách đã liên hệ với chúng tôi!!!</p></div>')
        })
        .fail(err => {
          console.log('err', err)
        })
    })
  })
}

function validation($form, data) {
  let isValid = true
  for (let property in data) {
    switch (property) {
      case 'name':
        if (!data[property] || data[property] === '') {
          isValid = false
          $form.find(`input[name="${property}"]`).addClass('invalid')
        }
        break

      case 'phone':
        if (!data[property] || data[property] === '') {
          isValid = false
          $form.find(`input[name="${property}"]`).addClass('invalid')
        }
        break

      // case 'email':
      //   if (!data[property] || data[property] === '' || !isEmail(data[property])) {
      //     isValid = false
      //     $form.find(`input[name="${property}"]`).addClass('invalid')
      //   }
      //   break

      // case 'subject':
      //   if (!data[property] || data[property] === '') {
      //     isValid = false
      //     $form.find(`input[name="${property}"]`).addClass('invalid')
      //   }
      //   break

      case 'body':
        if (!data[property] || data[property] === '') {
          isValid = false
          $form.find(`textarea[name="${property}"]`).addClass('invalid')
        }
        break
    }
  }

  return isValid
}

// function isEmail(email) {
//   return /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/.test(email)
// }
